import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f1aedcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white pt-[60px] mutilist-wrap" }
const _hoisted_2 = { class: "flex items-center justify-center mutilist-nav" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "new-list flex relative z-10" }

import { withDefaults, ref } from "vue";
import CommonSwiper from "./CommonSwiper.vue";
export interface IListItem {
  id: string;
  title: string;
  banner?: string;
  content?:string;
  digest?:string;
  children?: Array<IListItem>;
}
export interface IProps {
  NavList: Array<IListItem>;

  isEmpty?:boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MutilListSwiper',
  props: {
    NavList: { default: () => [] as Array<IListItem> },
    isEmpty: { type: Boolean }
  },
  emits: ['hanldeChange'],
  setup(__props: any, { emit: __emit }) {


const activeIndex = ref(0);
const emit = __emit
function changeActive(index) {
  activeIndex.value = index;
  emit('hanldeChange', index)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NavList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["list-item", activeIndex.value === index ? 'active' : '']),
          onClick: ($event: any) => (changeActive(index))
        }, _toDisplayString(item.title), 11, _hoisted_3))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "content w-[100%] box-border pt-[60px] mutilist-swiper",
      style: _normalizeStyle(`--active-index: ${activeIndex.value}`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CommonSwiper, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), null, 16)
      ])
    ], 4), [
      [_vShow, !_ctx.isEmpty]
    ])
  ]))
}
}

})